import { on, reducer } from 'ts-action';

import { keycloakMessage } from './actions';
import { KeycloakState } from './types';

/* eslint-disable no-alert, @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-unsafe-assignment */
const initialState: KeycloakState = {
    ready: (window as any).keycloakReadyDjango || false,
    authenticated: false,
    tokens: null,
};

export default reducer(
    initialState,
    on(keycloakMessage, (state, { payload: { event, tokens: tokensPayload } }) => {
        const { idToken, refreshToken, token } = (window as any).keycloak;
        const ready = state.ready || !!(window as any).keycloakReadyDjango || event === 'onReady';
        (window as any).keycloakReady = ready;

        return {
            ...state,
            ready,
            tokens: tokensPayload || state.tokens || { idToken, refreshToken, token },
            lastEvent: event || state.lastEvent,
        };
    })
);
/* eslint-enable no-alert, @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-unsafe-assignment */
